<template lang="pug">
modal(:max-width="500")
	.card.text-left
		.card-header.bg-info
			| Datos del cliente
			button.close(@click="cerrar") &times;
		.card-body
			.form-group
				label
					b Cliente
				input.form-control(placeholder="Nombre del cliente", v-model="datos.NombreCliente" :disabled="!permisos['contratos_editaNombreCliente']")
			.form-group
				label
					b CIF
				input.form-control(placeholder="CIF del cliente", v-model="datos.CIF")
			.form-group
				label
					b IBAN
				input.form-control(placeholder="IBAN del cliente", v-model="datos.IBAN", :disabled="!contrato.NecesarioIBAN")
			.form-group
				label
					b Representante
				input.form-control(placeholder="Representante del cliente", v-model="datos.Representante")
			.form-group
				label
					b Telefono
				input.form-control(placeholder="Telefono del cliente", v-model="datos.Telefono")
			.form-group
				label
					b Email
				input.form-control(placeholder="Email del cliente", v-model="datos.Email")
			.form-group
				label
					b Direccion
				textarea.form-control(rows="5", placeholder="Direccion del cliente", v-model="datos.Direccion")
		.card-footer
			button.btn.btn-sm.btn-primary(@click="actualizar")
				span.fa.fa-save.mr-2
				| Actualizar
</template>


<script>
import { mapGetters } from 'vuex'
export default {
	props: ['contrato'],
	data () {
		return {
			datos: {
				RelacionID: '',
				ContratoID: '',
				ClienteID: '',
				CIF: '',
				NombreCliente: '',
				Representante: '',
				Telefono: '',
				Email: '',
				Direccion: '',
				IBAN: ''
			}
		}
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos'
		})
	},
	created () {
		console.log('Creado')
		this.$http.get('mis-contratos/php/api/getDatosCliente.php?ContratoID=' + this.contrato.ContratoID)
			.then(res => {
				this.datos = res.data
			})
			.catch(e => {
				this.$responseError(e)
				this.cerrar()
			})
	},
	methods: {
		actualizar () {
			this.datos.ContratoID = this.contrato.ContratoID
			this.datos.ClienteID = this.contrato.ClienteID
			this.$http.post('mis-contratos/php/api/setDatosCliente.php', this.datos)
				.then(res => {
					this.$emit('actualizar', this.datos)
					this.cerrar()
				})
				.catch(this.$responseError)
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/visor-contrato/editor-datos-cliente.vue